import type { Theme } from '@mui/material/styles';
import { useMemo } from 'react';

const isFirefox = typeof window !== 'undefined' && navigator.userAgent.toLowerCase().includes('firefox');

export const useAudienceFormStyles = () => {
  return useMemo(
    () => ({
      container: {
        height: '100%',
        display: 'grid',
        gridTemplateRows: '1fr auto',
        gridTemplateColumns: '1fr minmax(352px, 30%)',
        gridTemplateAreas: `
          "main legend"
          "bottom legend"
        `,
        overflow: 'hidden',
        // Use contain: size for Chrome (provides sticky effect), but not for Firefox (causes blank page)
        ...(isFirefox ? {} : { contain: 'size' }),
      },
      mainContent: {
        gridArea: 'main',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'auto',
        height: '100%',
        borderRight: (theme: Theme) => `1px solid ${theme.palette.divider}`,
        borderBottom: (theme: Theme) => `1px solid ${theme.palette.divider}`,
      },
      legendContainer: {
        gridArea: 'legend',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'auto',
        backgroundColor: (theme: Theme) => theme.palette.background.boxLight as string,
        paddingBottom: (theme: Theme) => theme.spacing(3),
        // For Firefox: use position sticky to achieve the sticky effect
        ...(isFirefox
          ? {
              position: 'sticky' as const,
              top: 0,
              alignSelf: 'start',
              maxHeight: '100vh',
            }
          : { position: 'relative' as const }),
      },
      bottomBar: {
        gridArea: 'bottom',
        backgroundColor: (theme: Theme) => theme.palette.background.boxLight as string,
        borderRight: (theme: Theme) => `1px solid ${theme.palette.divider}`,
        padding: (theme: Theme) => theme.spacing(1, 4),
        display: 'flex',
        gap: (theme: Theme) => theme.spacing(2),
      },
    }),
    []
  );
};
